import { render, staticRenderFns } from "./PosPaperTaxInvoices.vue?vue&type=template&id=b209deb6&scoped=true&"
import script from "./PosPaperTaxInvoices.vue?vue&type=script&lang=js&"
export * from "./PosPaperTaxInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b209deb6",
  null
  
)

export default component.exports